export default "/bunjo/images/search/map/pin-land-active.svg?6c2b9d6657e78d5e9cc6354608a4fff7";